
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ReportPendingPODialog extends Serenity.EntityDialog<ReportPendingPORow, any> {
        protected getFormKey() { return ReportPendingPOForm.formKey; }
        protected getIdProperty() { return ReportPendingPORow.idProperty; }
        protected getLocalTextPrefix() { return ReportPendingPORow.localTextPrefix; }
        protected getNameProperty() { return ReportPendingPORow.nameProperty; }
        protected getService() { return ReportPendingPOService.baseUrl; }
        protected getDeletePermission() { return ReportPendingPORow.deletePermission; }
        protected getInsertPermission() { return ReportPendingPORow.insertPermission; }
        protected getUpdatePermission() { return ReportPendingPORow.updatePermission; }

        protected form = new ReportPendingPOForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
         
             let newCloseBtn: Serenity.ToolButton =
            {
                title: Q.text("ปิดเอกสาร"),
                hint: "Close Document",
                separator: false,
                cssClass: "closed-button",
                icon: "fa fa-save",
                onClick: (e) => {
                    Q.confirm('ยืนยันการปิดเอกสาร', () => {
                        // this.doDelete(() => {
                        console.log("Document Closed",this.form.SysDocNo.value);
                        //     this.dialogClose();
                        // });
                        Q.serviceRequest('Purchase/PoPurOrder/UpdateCancelAndUseFg', {
                            sysDocNo: this.form.SysDocNo.value,
                            CancelFg: "1",
                            UseFg: 1
                        }, response => {
                            Q.notifySuccess("ปิดเอกสารเรียบร้อยแล้ว");
                            this.dialogClose();
                        }, {
                            onError: (response) => {
                                Q.notifyError("เกิดข้อผิดพลาดในการปิดเอกสาร");
                            }
                        });

                    });
                }
            };
            buttons.push(newCloseBtn);
            return buttons;
        }


    }
}